// extracted by mini-css-extract-plugin
export var contentStyling = "ContentComponent-module--contentStyling--618d7";
export var renderedContent = "ContentComponent-module--renderedContent--14089";